import {useEffect, useState} from "react";
import QRCode from "qrcode";

interface Props {
    href: string;
}

function QrCodeImage(props: Props) {
    const [qrCodeImage, setQrCodeImage] = useState<string>("");

    useEffect(() => {
        void generateQrImageUrl();
    }, [props.href]);

    async function generateQrImageUrl() {
        if (!props.href) {
            return;
        }
        const url = await QRCode.toDataURL(props.href);
        setQrCodeImage(url);
    }

    if (!qrCodeImage) {
        return null;
    }

    return (
        <div className="qr-code-image">
            <img
                className="qr-code-image_overlay"
                src={`${import.meta.env.VITE_CDN_URL}/images/qr-code.png`}
                alt="QR Overlay"
            />
            <img
                className="qr-code-image_render"
                src={qrCodeImage}
                alt={props.href}
            />
        </div>
    );

}

export default QrCodeImage;
